<template>
    <div class="modal fade" id="discountExpirationModal" tabindex="-1" role="dialog" aria-labelledby="discountExpirationModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body text-center">
                    <h2 id="discountExpirationModalLabel" class="mb-3">Discount Code Expired</h2>
                    <p>The discount code you entered has expired and can no longer be used.<span v-if="!buttonTriggered"> This code will be removed from your order.</span></p>
                    <button type="button" class="w-full rounded-md mt-8 py-2 bg-blue-600 hover:bg-blue-700 text-sm text-white font-bold disabled:bg-gray-500 disabled:text-gray-300 disabled:cursor-not-allowed" @click="closeModal" data-dismiss="modal">Okay</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            validated: false,
            discountCode: null,
            buttonTriggered: false
        };
    },
    methods: {
        showExpiredModal() {
            this.buttonTriggered = false;
            $('#discountExpirationModal').modal('show');
        },
        showExpiredModalButtonTriggered() {
            this.buttonTriggered = true;
            $('#discountExpirationModal').modal('show');
        },
        closeModal() {
            $('#discountExpirationModal').modal('hide');
            this.removeDiscount();
        },
        removeDiscount() {
            this.validated = false;
            this.discountCode = null;
            this.$emit('update:makePayment', true);
            this.$emit('remove');
        },
    },
};
</script>
